import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from '../../shared/components/LinkButton';
import { PsRoutes } from '../../shared/routing/Routes';
import { I18nUtils } from '../../../i18n/I18nUtils';
import RouterUtils from '../../shared/routing/RouterUtils';
import { ActiveBadge } from '../../shared/components/ActiveLabel';
import { PsUser } from '../../shared/model/PsUser';

export default class UserRow extends React.Component {

    render() {
        const { user } = this.props;

        return (
            <tr className={user.isDisabled() ? 'disabled-user' : ''}>
                <td><ActiveBadge active={user.isEnabled()}/></td>
                <td><span>{user.role().description()}</span></td>
                <td><strong>{user.name()}</strong></td>
                <td><strong>{user.lastName()}</strong></td>
                <td><span>{user.email()}</span></td>
                <td><span>{user.company()}</span></td>
                <td>
                    <LinkButton
                        to={RouterUtils.generateRoute(PsRoutes.USERS_DETAIL, { id: user.id() })}
                        text={I18nUtils.tr('TR_EDITAR')}
                        className={'btn-block btn-sm'}
                    />
                </td>
            </tr>
        );
    }

}

UserRow.propTypes = {
    user: PropTypes.objectOf(PsUser).isRequired,
};

UserRow.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/users/components/UserRow.jsx